import { render } from "./ProjectOverview.vue?vue&type=template&id=6e399808&scoped=true"
import script from "./ProjectOverview.vue?vue&type=script&lang=js"
export * from "./ProjectOverview.vue?vue&type=script&lang=js"

import "./ProjectOverview.vue?vue&type=style&index=0&id=6e399808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e399808"]])

export default __exports__